/** Tints mirror the category color tokens in src/styles/tokens.css. */
export const CATEGORIES = [
  { id: 'books', name: 'Books', glyph: 'Bk', tint: '#BFE3D9', deep: '#0F6B5C' },
  { id: 'tshirts', name: 'T-shirts', glyph: 'Te', tint: '#FFD9C7', deep: '#C2451A' },
  { id: 'stickers', name: 'Stickers', glyph: 'St', tint: '#F5E6A8', deep: '#8A6D00' },
  { id: 'figurines', name: 'Figurines', glyph: 'Fg', tint: '#D9D2F0', deep: '#5B4BA6' },
  { id: 'posters', name: 'Posters', glyph: 'Po', tint: '#F7CFE0', deep: '#B0356F' },
];
